"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAchievementDefinition = exports.AchievementDefinitionSchema = exports.AchievementAssociatedEventNameSchema = void 0;
const zod_1 = require("zod");
exports.AchievementAssociatedEventNameSchema = zod_1.z.union([
    zod_1.z.literal("FirstLanguageSelected"),
    zod_1.z.literal("CompletedLearnHowToDoReviews"),
    zod_1.z.literal("CompletedVocabSet"),
    zod_1.z.literal("CompletedReview"),
    zod_1.z.literal("CompletedGuidedLearningChapter1"),
    zod_1.z.literal("CompletedGuidedLearning"),
    zod_1.z.literal("CompletedGuidedLearningWeek1"),
    zod_1.z.literal("CompletedGuidedLearningWeek2"),
    zod_1.z.literal("CompletedGuidedLearningWeek3"),
    zod_1.z.literal("UserWithoutLanguageLearnerAchievement"),
    zod_1.z.literal("MinimalPairOnbaordingAnswered"),
    zod_1.z.literal("CompletedPronunciationLesson"),
    zod_1.z.literal("ReadFlashtip"),
    zod_1.z.literal("CreatedWordFlashcards"),
    zod_1.z.literal("MarkedWordAsSkipped"),
    zod_1.z.literal("MarkedWordAsKnown"),
    zod_1.z.literal("PersonalImageUploaded"),
    zod_1.z.literal("PersonalDrawingImageUploaded"),
    zod_1.z.literal("SeeTranslation"),
    zod_1.z.literal("FlashcardDeleted"),
    zod_1.z.literal("ReviewImageUpdated"),
    zod_1.z.literal("AdvancedImageSearch"),
    zod_1.z.literal("UndoReviewAnswer"),
    zod_1.z.literal("Completed100PercentCorrectReview"),
    zod_1.z.literal("Completed50PercentOrMoreCorrectReview"),
]);
exports.AchievementDefinitionSchema = zod_1.z.object({
    associatedEvents: zod_1.z.array(exports.AchievementAssociatedEventNameSchema),
    category: zod_1.z.number(),
    hiddenUntilEarned: zod_1.z.boolean(),
    id: zod_1.z.string(),
    orderInSubCategory: zod_1.z.number(),
    perLanguage: zod_1.z.boolean(),
    subCategoryId: zod_1.z.number(),
});
const isAchievementDefinition = (v) => exports.AchievementDefinitionSchema.safeParse(v).success;
exports.isAchievementDefinition = isAchievementDefinition;
//# sourceMappingURL=achievements_metadata_types.js.map